import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { SocietyClientDataForm, SocietyClientFilters } from '../../models/SocietyClient';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useSocietyClientService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetSocietyClients, setFetchingGetSocietyClients] = useState(false);
    const [fetchingStoreSocietyClient, setFetchingStoreSocietyClient] = useState(false);
    const [fetchingEditSocietyClient, setFetchingEditSocietyClient] = useState(false);
    const [fetchingCreateSocietyClient, setFetchingCreateSocietyClient] = useState(false);
    const [fetchingUpdateSocietyClient, setFetchingUpdateSocietyClient] = useState(false);
    const [fetchingDeleteSocietyClient, setFetchingDeleteSocietyClient] = useState(false);
    const [fetchingActiveSocietyClient, setFetchingActiveSocietyClient] = useState(false);

    const getSocietyClients = (filters: SocietyClientFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        // Si hay society_id, usar el endpoint específico, sino usar el endpoint general
        let url: string;
        if (filters.society_id && filters.society_id > 0) {
            url = `${EndPoints.SOCIETY_CLIENTS.GET_SOCIETY_CLIENTS_BY_SOCIETY.replace(':society_id', filters.society_id.toString())}?${queryString}`;
        } else {
            url = `${EndPoints.SOCIETY_CLIENTS.GET_SOCIETY_CLIENTS}?${queryString}`;
        }

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetSocietyClients
        });
    };

    const createSocietyClient = (societyId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SOCIETY_CLIENTS.CREATE_SOCIETY_CLIENT.replace(':society_id', societyId.toString()),
            setFetching: setFetchingCreateSocietyClient
        });
    };

    const storeSocietyClient = (societyClient: SocietyClientDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SOCIETY_CLIENTS.STORE_SOCIETY_CLIENT,
            body: societyClient,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingStoreSocietyClient
        });
    };

    const editSocietyClient = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SOCIETY_CLIENTS.EDIT_SOCIETY_CLIENT.replace(':id', id.toString()),
            setFetching: setFetchingEditSocietyClient
        });
    };

    const updateSocietyClient = (id: number, societyClient: SocietyClientDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SOCIETY_CLIENTS.UPDATE_SOCIETY_CLIENT.replace(':id', id.toString()),
            body: societyClient,
            setFetching: setFetchingUpdateSocietyClient
        });
    };

    const deleteSocietyClient = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SOCIETY_CLIENTS.DELETE_SOCIETY_CLIENT.replace(':id', id.toString()),
            setFetching: setFetchingDeleteSocietyClient
        });
    };

    const activeSocietyClient = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            body: { active: active },
            url: EndPoints.SOCIETY_CLIENTS.ACTIVE_SOCIETY_CLIENT.replace(':id', id.toString()),
            setFetching: setFetchingActiveSocietyClient
        });
    };

    return {
        fetchingGetSocietyClients,
        fetchingStoreSocietyClient,
        fetchingEditSocietyClient,
        fetchingCreateSocietyClient,
        fetchingUpdateSocietyClient,
        fetchingDeleteSocietyClient,
        fetchingActiveSocietyClient,
        getSocietyClients,
        createSocietyClient,
        storeSocietyClient,
        editSocietyClient,
        updateSocietyClient,
        deleteSocietyClient,
        activeSocietyClient
    };
};

export default useSocietyClientService;
